import { unwrap } from '../intent-client.js';
export function createCryptoDepositClient(transport) {
    return {
        async capability(surface, signal) {
            return unwrap(await transport.GET('/v1/onramp/crypto-deposits/capability', {
                params: { query: { surface } },
                ...(signal ? { signal } : {}),
            })).available;
        },
        async create(input, signal) {
            return unwrap(await transport.POST('/v1/onramp/crypto-deposits', {
                body: input,
                ...(signal ? { signal } : {}),
            }));
        },
        async get(id, signal) {
            return unwrap(await transport.GET('/v1/onramp/crypto-deposits/{id}', {
                params: { path: { id } },
                ...(signal ? { signal } : {}),
            }));
        },
        async instructions(id, routeId, signal) {
            return unwrap(await transport.POST('/v1/onramp/crypto-deposits/{id}/instructions', {
                params: { path: { id } },
                body: { routeId },
                ...(signal ? { signal } : {}),
            }));
        },
        async reconcile(id, signal) {
            return unwrap(await transport.POST('/v1/onramp/crypto-deposits/{id}/reconcile', {
                params: { path: { id } },
                ...(signal ? { signal } : {}),
            }));
        },
    };
}
